import { render, staticRenderFns } from "./DetailInquiry.vue?vue&type=template&id=26ff3fce&scoped=true"
import script from "./DetailInquiry.vue?vue&type=script&lang=js"
export * from "./DetailInquiry.vue?vue&type=script&lang=js"
import style0 from "./DetailInquiry.vue?vue&type=style&index=0&id=26ff3fce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ff3fce",
  null
  
)

export default component.exports